/**
 * acadGapsBuilder (S3) — notícias broadcast, notas multidisciplinar, CPA analítico.
 *
 * @since S3 (gaps SA→AVA)
 */
import type { $Fetch } from 'ofetch';

import {
  HttpNoticiaGateway, HttpNotasMultidisciplinarGateway, HttpCpaRelatorioAnaliticoGateway,
} from '@/infrastructure/http/HttpAcadGapsGateways';
import {
  ListNoticias, CreateNoticia, UpdateNoticia, RemoveNoticia,
  GetNotasMultidisciplinar, GetCpaRelatorioAnalitico,
} from '@/application/usecase/AcadGapsUseCaseImpl';

export function buildAcadGapsSlice(httpClient: $Fetch) {
  const noticiaGateway = new HttpNoticiaGateway(httpClient);
  const notasGateway = new HttpNotasMultidisciplinarGateway(httpClient);
  const cpaAnaliticoGateway = new HttpCpaRelatorioAnaliticoGateway(httpClient);

  const useCases = {
    listNoticias: new ListNoticias(noticiaGateway),
    createNoticia: new CreateNoticia(noticiaGateway),
    updateNoticia: new UpdateNoticia(noticiaGateway),
    removeNoticia: new RemoveNoticia(noticiaGateway),
    getNotasMultidisciplinar: new GetNotasMultidisciplinar(notasGateway),
    getCpaRelatorioAnalitico: new GetCpaRelatorioAnalitico(cpaAnaliticoGateway),
  };

  return { useCases };
}
